import { YearsFromUni } from "../../../../content/posts/my-first-open-source-project/YearsFromUni";
import * as React from 'react';
export default {
  YearsFromUni,
  React
};